import { AxiosResponse } from "axios";
import { AliasViewModel } from "../aliases/AliasStore";
import { MatchParticipantViewModel } from "../matches/MatchesStore";
import axios, { APIWrapperResponse, DefaultResponse, TypedResponse } from "../general/HttpClient";

export function getGames() {
    return axios.get("/api/Games/getGames").then((response: AxiosResponse<APIWrapperResponse<Array<GameViewModel>>>) => {
        return response.data.result;
    });
}

export function getGame(id) {
    return axios.get(`/api/Games/getGame/${id}`).then((response: AxiosResponse<APIWrapperResponse<GameViewModel>>) => {
        return response;
    });
}

export function createGame(request: CreateGameRequest) {
    return axios.post(`/api/Games/createGame`, request).then((response: AxiosResponse<APIWrapperResponse<TypedResponse<GameViewModel>>>) => {
        return response.data.result;
    });
}

export function updateGame(request: UpdateGameRequest | GameViewModel) {
    return axios.put(`/api/Games/updateGame`, request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export interface GameViewModel {
    id: string;
    name: string;
    description: string;
    about: string;
    logoUri: string;
    splashUri: string;
    gameMedia: GameMedia;
    isPublic: boolean;
    archived?: boolean;
}

export interface GameMedia {
    socialMediaLinks: SocialMediaLink[];
    screenshots: string[];
    videos: string[];
}

export interface SocialMediaLink {
    link: string;
    icon: string;
}

export interface CreateGameRequest {
    organizationID: string;
    name: string;
    logoUri: string;
    logoContent: string;
    splashUri: string;
    splashContent: string;
    content: string;
    description: string;
    isPublic: boolean;
    gameFileExt: string;
}

export interface UpdateGameRequest {
    organizationID: string;
    id: string;
    name: string;
    logoUri: string;
    logoContent?: string;
    splashUri: string;
    splashContent?: string;
    description: string;
    content: string;
    isPublic: boolean;
    gameFileExt: string;
}
